
























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, RiskTextForScore } from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";

@Component
export default class RiskStats extends Vue {
  @Prop() public gender!: Gender;
  @Prop() public score!: number;
  @Prop() public commissioned!: boolean;

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }

  private get isMale(): boolean {
    return this.gender === Gender.Male;
  }

  private get isLowerRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Lower;
  }

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private get isHigherRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get riskName(): string {
    return RiskTextForScore(this.score);
  }
}
